const ACTIONS = {
  setSelectedTransaction: 'setSelectedTransaction',
  handleSessionOpening: 'handleSessionOpening',
  createSession: 'createSession',
  sendMessage: 'sendMessage',
  getCurrentSession: 'getCurrentSession',
  askForFeedback: 'askForFeedback',
  sendFeedbackMessage: 'sendFeedbackMessage',
  closeCurrentSession: 'closeCurrentSession',
};

/**
 * Use this in every invocation of `dispatch` inside any actions
 * @type {ACTIONS}
 */
export const ACTION_TYPES =
  process.env.NODE_ENV === 'test'
    ? Object.entries(ACTIONS).reduce(
        (result, [key, value]) => ({
          ...result,
          [key]: `mitra-chat-gpt/${value}`,
        }),
        {}
      )
    : ACTIONS;
